export * from './useAnonymousId';
//# sourceMappingURL=index.js.map